<main class="auth-page min-vh-100 loader-page bg-white text-dark" aria-label="Siyanda Platinum Platform loading">
    <div class="row g-0 min-vh-100">
        <section class="col-lg-6 auth-brand-panel text-white p-4 p-lg-4 d-none d-lg-flex flex-column justify-content-between overflow-hidden position-relative bg-dark">
            <router-link to="/" class="auth-brand-mark d-inline-flex mb-3 align-self-start bg-white rounded-3 p-2" aria-label="Siyanda Platinum home">
                <span class="auth-brand-mark-img d-block" role="img" aria-label="Siyanda Bakgatla Platinum Mine"></span>
            </router-link>

            <div>
                <p class="text-uppercase text-warning fw-bold text-xxs mb-2">
                    Siyanda Platinum Platform
                </p>
                <h1 class="h3 fw-bold mb-2">Opening your operations view.</h1>
                <p class="text-white-50 mb-0">
                    Production, safety, and sustainability insights are being prepared.
                </p>
            </div>

            <div>
                <hr class="my-3" />
                <div class="row g-3">
                    <div class="col-4">
                        <span class="d-block text-uppercase text-white-50 text-xxs mb-1">Production</span>
                        <span class="d-block fw-bold text-warning">Tracked daily</span>
                    </div>
                    <div class="col-4">
                        <span class="d-block text-uppercase text-white-50 text-xxs mb-1">Safety</span>
                        <span class="d-block fw-bold text-warning">Always on</span>
                    </div>
                    <div class="col-4">
                        <span class="d-block text-uppercase text-white-50 text-xxs mb-1">Sustainability</span>
                        <span class="d-block fw-bold text-warning">Community first</span>
                    </div>
                </div>
            </div>
        </section>

        <section class="col-lg-6 bg-white text-dark d-flex align-items-center justify-content-center p-4 p-md-5">
            <div class="col-12 col-sm-10 col-md-8 col-lg-9 col-xl-7">
                <div class="d-flex align-items-center justify-content-between mb-4">
                    <div>
                        <p class="text-uppercase text-secondary fw-bold text-xxs mb-1">
                            Union Mine
                        </p>
                        <h2 class="h3 fw-bold mb-0">Preparing dashboard data</h2>
                    </div>
                    <span class="badge rounded-pill px-3 py-2" :class="all_done ? 'text-bg-success' : 'text-bg-warning text-dark'">
                        {{ all_done ? 'Ready' : progress + '%' }}
                    </span>
                </div>

                <div class="progress mb-4 siyanda-progress-thin" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100">
                    <div class="progress-bar loader-progress-bar bg-warning" :style="{ width: progress + '%' }"></div>
                </div>

                <div class="list-group list-group-flush border rounded-3 overflow-hidden">
                    <div
                        class="list-group-item d-flex align-items-center gap-3 py-3"
                        v-for="(step, index) in steps"
                        :key="step.key"
                        :class="loader_step_row_class(index)"
                    >
                        <span
                            class="loader-step-icon siyanda-icon-badge-sm rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0"
                            :class="loader_step_badge_class(index)"
                        >
                            <i :class="loader_step_icon_class(step, index)"></i>
                        </span>
                        <div>
                            <p class="fw-bold text-dark mb-0">{{ step.label }}</p>
                            <p class="text-secondary text-xxs mb-0">{{ step.description }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</main>
